//* Espejo de ACTIVITY_STATES + ACTIVITY_TRANSITIONS del motor (api-rendafin activity-state.enum.ts).
//* severity para <p-tag>. transitions para poblar el dropdown de cambio de estado en el detalle de tarea.
export const ACTIVITY_STATES = ['Pendiente', 'En progreso', 'En revisión', 'Bloqueada', 'Done', 'Cancelada'] as const
export type ActivityState = (typeof ACTIVITY_STATES)[number]

export interface ActivityStateMeta {
  label: string
  severity: 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'contrast'
}

export const ACTIVITY_STATE_META: Record<string, ActivityStateMeta> = {
  Pendiente: { label: 'Pendiente', severity: 'secondary' },
  'En progreso': { label: 'En progreso', severity: 'info' },
  'En revisión': { label: 'En revisión', severity: 'warning' },
  Bloqueada: { label: 'Bloqueada', severity: 'danger' },
  Done: { label: 'Completada', severity: 'success' },
  Cancelada: { label: 'Cancelada', severity: 'contrast' },
}

export function activityStateMeta(state: string): ActivityStateMeta {
  return ACTIVITY_STATE_META[state] ?? { label: state, severity: 'secondary' }
}

//* Transiciones permitidas (espejo de ACTIVITY_TRANSITIONS). El detalle de tarea ofrece solo estas.
export const ACTIVITY_TRANSITIONS: Record<string, string[]> = {
  Pendiente: ['En progreso', 'Bloqueada', 'Cancelada', 'Done'],
  'En progreso': ['En revisión', 'Bloqueada', 'Done', 'Cancelada'],
  'En revisión': ['En progreso', 'Done', 'Cancelada'],
  Bloqueada: ['En progreso', 'Cancelada'],
  Done: [],
  Cancelada: [],
}

export function allowedTransitions(from: string): string[] {
  return ACTIVITY_TRANSITIONS[from] ?? []
}

//* Opciones planas para el dropdown de cambio de estado (el backend valida la transición real).
export const FUNNEL_TASK_STATE_OPTIONS = ACTIVITY_STATES.map((s) => ({ label: ACTIVITY_STATE_META[s].label, value: s as string }))
